export const mockAssessments = {
    1: {
      id: 1,
      title: "Health and Demographics",
      description: "General health and demographic information",
      questions: [
        {
          id: 127072,
          body: "Are you currently married or living with a domestic partner or significant other?",
          type: "single-selection",
          status: "incomplete",
          options: ["Yes", "No"]
        },
        {
          id: 127069,
          body: "Are you of Hispanic, Latino, or Spanish origin? (select one only)",
          type: "single-selection",
          status: "incomplete",
          options: ["Yes", "No"]
        },
        {
          id: 127064,
          body: "Do you currently take any medication(s) or receive any treatment(s) to prevent or reduce the frequency or severity of migraine (i.e., preventive medication)?",
          type: "single-selection",
          status: "complete",
          options: ["Yes", "No"]
        },
        {
          id: 127066,
          body: "Do you currently use any of the following medications for any reason, including for your migraine? (Select any that apply)",
          type: "multiple-selection",
          status: "incomplete",
          options: ["Medication A", "Medication B", "Medication C", "Other"]
        },
        {
          id: 127074,
          body: "How many children live (part-time or full-time) in your household?",
          type: "dropdown-single-selection",
          status: "incomplete",
          options: ["0", "1", "2", "3", "4", "5+"]
        },
        {
          id: 127059,
          body: "How old were you when you were first told by a doctor or other health care provider that you have migraine?",
          type: "dropdown-single-selection",
          status: "complete",
          options: ["Under 12", "12-17", "18-24", "25-34", "35-44", "45-54", "55+"]
        },
        {
          id: 127075,
          body: "How would you describe how much education you have completed?",
          type: "dropdown-single-selection",
          status: "incomplete",
          options: ["Less than high school", "High school graduate", "Some college", "College graduate", "Postgraduate"]
        },
        {
          id: 127076,
          body: "How would you describe your current employment status? (select all that apply)",
          type: "multiple-selection",
          status: "incomplete",
          options: ["Employed full-time", "Employed part-time", "Unemployed", "Retired", "Student", "Homemaker", "Other"]
        },
        {
          id: 127060,
          body: "In the last 4 weeks, how many days did you have headache of any kind (including migraine)?",
          type: "dropdown-single-selection",
          status: "complete",
          options: ["0 days", "1-7 days", "8-14 days", "15-21 days", "22-28 days"]
        },
        {
          id: 127061,
          body: "In the last 4 weeks, how many days were you completely free of headache of any kind (including migraine)?",
          type: "dropdown-single-selection",
          status: "complete",
          options: ["0 days", "1-7 days", "8-14 days", "15-21 days", "22-28 days"]
        },
        {
          id: 127073,
          body: "Other than yourself, how many adults live in your household?",
          type: "dropdown-single-selection",
          status: "incomplete",
          options: ["0", "1", "2", "3", "4", "5+"]
        },
        {
          id: 127062,
          body: "Over the past year, have you taken medication(s) to treat your migraine headaches when they happen? (These may be over-the-counter or prescription).",
          type: "single-selection",
          status: "complete",
          options: ["Yes", "No"]
        },
        {
          id: 127058,
          body: "What is your current age?",
          type: "dropdown-single-selection",
          status: "complete",
          options: ["Under 18", "18-24", "25-34", "35-44", "45-54", "55-64", "65+"]
        },
        {
          id: 127068,
          body: "What is your gender? (select one only)",
          type: "single-selection",
          status: "incomplete",
          options: ["Male", "Female", "Non-binary", "Prefer not to say"]
        },
        {
          id: 127071,
          body: "What language do you speak most of the time at home? (select one only)",
          type: "single-selection",
          status: "incomplete",
          options: ["English", "Spanish", "Chinese", "Other"]
        },
        {
          id: 127065,
          body: "What medication(s) do you take or what treatment(s) do you receive to prevent or reduce the frequency or severity of migraine (i.e., preventive medication)? (select all that apply)",
          type: "multiple-selection",
          status: "incomplete",
          options: ["Medication A", "Medication B", "Medication C", "Other"]
        },
        {
          id: 127063,
          body: "What medication(s) have you taken within the past year to treat your migraine headaches when they happen? (select all that apply)",
          type: "multiple-selection",
          status: "complete",
          options: ["Medication A", "Medication B", "Medication C", "Other"]
        },
        {
          id: 127070,
          body: "What race best describes you? (select all that apply)",
          type: "multiple-selection",
          status: "incomplete",
          options: ["White", "Black or African American", "American Indian or Alaska Native", "Asian", "Native Hawaiian or Other Pacific Islander", "Other"]
        },
        {
          id: 127067,
          body: "What sex were you assigned at birth? (select one only)",
          type: "single-selection",
          status: "incomplete",
          options: ["Male", "Female"]
        },
        {
          id: 127077,
          body: "Which of these income categories comes closest to the total yearly income for your household, from all sources? (select one only)",
          type: "single-selection",
          status: "incomplete",
          options: ["Under $25,000", "$25,000 - $49,999", "$50,000 - $74,999", "$75,000 - $99,999", "$100,000 and over"]
        }
      ]
    },
    2: {
      id: 2,
      title: "MiCOAS 14-Day Assessment",
      description: "Bi-weekly assessment of migraine symptoms and impact",
      questions: [
        {
          id: 127099,
          body: "How often did you feel frustrated?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127079,
          body: "How often did you feel good?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127100,
          body: "How often did you feel irritable?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127098,
          body: "How often did you feel sad or depressed?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127096,
          body: "How often did you feel worried about having a migraine attack?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127095,
          body: "How often did you feel you did not have control over your life?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127093,
          body: "How often did you have to cancel or change your plans for social or recreation activities?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127084,
          body: "How often did you have to miss your regular daily activities? Include times that you stopped early or started late.",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127081,
          body: "How often did you want to spend time alone in a comfortable environment?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127080,
          body: "How often were you able to enjoy all or part of a day?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127097,
          body: "How often were you concerned that your migraine attacks would affect other people's lives?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127092,
          body: "How often were you reluctant to make plans with other people?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127083,
          body: "How often were you too tired to do your regular daily activities?",
          type: "single-selection",
          status: "incomplete",
          options: ["Never", "Rarely", "Sometimes", "Frequently", "Always"]
        },
        {
          id: 127078,
          body: "On how many days did you have migraine symptoms?",
          type: "single-selection",
          status: "incomplete",
          options: ["0 days", "1-3 days", "4-6 days", "7-10 days", "More than 10 days"]
        },
        {
          id: 127113,
          body: "Was it difficult for you to carry out tasks that required many steps?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127101,
          body: "Was it difficult for you to concentrate?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127087,
          body: "Was it difficult for you to do activities because you were sensitive to light?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127088,
          body: "Was it difficult for you to do activities because you were sensitive to smells?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127089,
          body: "Was it difficult for you to do activities because you were sensitive to sound?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127090,
          body: "Was it difficult for you to do errands?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127105,
          body: "Was it difficult for you to do tasks that required you to concentrate?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127085,
          body: "Was it difficult for you to do usual activities that require physical exertion, like going up stairs?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127086,
          body: "Was it difficult for you to do your regular household chores?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
        {
          id: 127082,
          body: "Was it difficult for you to do your usual day-to-day activities?",
          type: "single-selection",
          status: "incomplete",
          options: ["Very difficult", "Somewhat difficult", "Neutral", "Somewhat easy", "Very easy"]
        },
      ]
    },
  };
  
  export const getAssessmentById = (assessmentId) => {
    // Convert string ID to number since URL parameters come as strings
    const id = parseInt(assessmentId, 10);
    return mockAssessments[id];
  };
  
  export const getAllAssessments = () => {
    return Object.values(mockAssessments);
  };